import { render } from "./masterDashboard.vue?vue&type=template&id=782ea9c6&scoped=true&ts=true"
import script from "./masterDashboard.vue?vue&type=script&lang=ts"
export * from "./masterDashboard.vue?vue&type=script&lang=ts"

import "./masterDashboard.vue?vue&type=style&index=0&id=782ea9c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782ea9c6"]])

export default __exports__